import React, { useState } from 'react';
import { Settings, Key, Zap, CheckCircle2, Save } from 'lucide-react';
import { getGeminiKey, setGeminiKey } from '../modules/buildpro/BuildPro';
import { getGroqKey, setGroqKey } from '../services/groqService';

export const ConfiguracionPage = () => {
  const [apiKeyInput, setApiKeyInput] = useState(getGeminiKey() || '');
  const [groqKeyInput, setGroqKeyInput] = useState(getGroqKey() || '');
  
  const [savedGemini, setSavedGemini] = useState(false);
  const [savedGroq, setSavedGroq] = useState(false);

  const handleSaveGemini = () => {
    setGeminiKey(apiKeyInput);
    setSavedGemini(true);
    setTimeout(() => setSavedGemini(false), 2000);
  };

  const handleSaveGroq = () => {
    setGroqKey(groqKeyInput);
    setSavedGroq(true);
    setTimeout(() => setSavedGroq(false), 2000);
  };

  return (
    <div className="max-w-4xl mx-auto pb-12">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-100 flex items-center gap-3">
            <Settings className="text-blue-500" />
            Configuración Global
          </h1>
          <p className="text-gray-400 mt-2">Parametriza los motores de IA y preferencias de las obras.</p>
        </div>
      </div>

      <div className="space-y-6">
        {/* Gemini AI Settings */}
        <div className="p-6 rounded-2xl bg-[#0d1117] border border-white/5 shadow-xl">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-blue-500/10 flex items-center justify-center">
              <Key size={20} className="text-blue-400" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-100">Google Gemini API</h2>
              <p className="text-sm text-gray-400">Motor principal para análisis visual de planos y mediciones automatizadas.</p>
            </div>
          </div>
          
          <div className="flex gap-4 items-end">
            <div className="flex-1">
              <label className="block text-xs font-medium text-gray-400 mb-1.5 uppercase tracking-wider">Clave de acceso (API Key)</label>
              <input
                type="password"
                value={apiKeyInput}
                onChange={e => setApiKeyInput(e.target.value)}
                className="w-full bg-[#010409] border border-white/10 rounded-xl px-4 py-2.5 text-gray-100 focus:outline-none focus:border-blue-500/50 transition-colors"
                placeholder="AIzaSy..."
              />
            </div>
            <button
              onClick={handleSaveGemini}
              className={`px-6 py-2.5 rounded-xl font-semibold transition-all flex items-center gap-2 ${savedGemini ? 'bg-green-500/20 text-green-400' : 'bg-blue-600 text-white hover:bg-blue-500'}`}
            >
              {savedGemini ? <><CheckCircle2 size={18} /> Guardada</> : <><Save size={18} /> Guardar</>}
            </button>
          </div>
          <p className="text-xs text-gray-500 mt-3">Consigue tu clave gratuita en <a href="https://aistudio.google.com/app/apikey" target="_blank" rel="noreferrer" className="text-blue-500 hover:text-blue-400">Google AI Studio</a>.</p>
        </div>

        {/* Groq AI Settings */}
        <div className="p-6 rounded-2xl bg-[#0d1117] border border-white/5 shadow-xl">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-purple-500/10 flex items-center justify-center">
              <Zap size={20} className="text-purple-400" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-100 flex items-center gap-2">
                Groq AI (Llama 3.3)
                <span className="px-2 py-0.5 rounded text-[10px] uppercase font-bold bg-purple-500/20 text-purple-400">Velocidad</span>
              </h2>
              <p className="text-sm text-gray-400">Motor conversacional ultrarrápido para sugerir alternativas, explicar partidas y chatear con la obra.</p>
            </div>
          </div>
          
          <div className="flex gap-4 items-end">
            <div className="flex-1">
              <label className="block text-xs font-medium text-gray-400 mb-1.5 uppercase tracking-wider">Clave de acceso (API Key)</label>
              <input
                type="password"
                value={groqKeyInput}
                onChange={e => setGroqKeyInput(e.target.value)}
                className="w-full bg-[#010409] border border-white/10 rounded-xl px-4 py-2.5 text-gray-100 focus:outline-none focus:border-purple-500/50 transition-colors"
                placeholder="gsk_..."
              />
            </div>
            <button
              onClick={handleSaveGroq}
              className={`px-6 py-2.5 rounded-xl font-semibold transition-all flex items-center gap-2 ${savedGroq ? 'bg-green-500/20 text-green-400' : 'bg-purple-600 text-white hover:bg-purple-500'}`}
            >
              {savedGroq ? <><CheckCircle2 size={18} /> Guardada</> : <><Save size={18} /> Guardar</>}
            </button>
          </div>
          <p className="text-xs text-gray-500 mt-3">Consigue tu clave gratuita en <a href="https://console.groq.com/keys" target="_blank" rel="noreferrer" className="text-purple-500 hover:text-purple-400">Groq Console</a>.</p>
        </div>

        {/* Generales Obra Settings */}
        <div className="p-6 rounded-2xl bg-[#0d1117] border border-white/5 shadow-xl opacity-60">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-orange-500/10 flex items-center justify-center">
              <Settings size={20} className="text-orange-400" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-100">Preferencias de Obra (Próximamente)</h2>
              <p className="text-sm text-gray-400">Configura IVA por defecto, logos para PDF y ubicaciones base.</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
